import { cloneDeep } from 'lodash';
import { action, makeObservable } from 'mobx';
import { IAnnotationService } from '../annotation.service';
import { ISegmentation } from '../annotations.interface';
import { IAnnotationsStore } from '../annotations.store';
import { IFreeDrawSegmentationService } from '../freeDrawSegmentation.service';
import { AnnotationCommand } from './annotationCommand';

export class ChangeStateCommand extends AnnotationCommand {
  private readonly stateBefore: ISegmentation[];
  private readonly stateAfter: ISegmentation[];
  private readonly applyState: (segmentations: ISegmentation[]) => void;

  constructor(
    annotationService: IAnnotationService,
    annotationsStore: IAnnotationsStore,
    freeDrawSegmentationService: IFreeDrawSegmentationService,
    stateBefore: ISegmentation[],
    stateAfter: ISegmentation[],
    applyState: (segmentations: ISegmentation[]) => void
  ) {
    super(annotationService, annotationsStore, freeDrawSegmentationService);

    makeObservable(this, {
      executeUndo: action,
      executeRedo: action,
    });

    this.stateBefore = cloneDeep(stateBefore);
    this.stateAfter = cloneDeep(stateAfter);
    this.applyState = applyState;
  }

  executeUndo(): void {
    super.executeUndo();
    this.applyState(cloneDeep(this.stateBefore));
  }

  executeRedo(): void {
    super.executeRedo();
    this.applyState(cloneDeep(this.stateAfter));
  }
}
